import { defineStore } from 'pinia'
import { useNotifications } from '@snowshoe-frontend/toast-component'

export const useNotificationsStore = defineStore('notificationsStore', () => {
  const { notifications, removeNotification, setNotification } =
    useNotifications()

  return {
    notifications,

    setNotification,
    removeNotification
  }
})
